// src/App.js
import { useEffect, useState } from 'react';
import {
  Form,
  Field,
  Button,
  Toast,
  Divider,
  Radio,
  Space,
  Checkbox,
} from 'react-vant';
import { Helmet, history } from '@umijs/max';
import './index.less';
import { EyeO, ClosedEye } from '@react-vant/icons';
import { register } from '@/service/login';
import { validatePassword, validateIdCard } from '@/utils/validate';
// import md5 from 'js-md5';
import AgreementModal from './components/AgreementModal';

const Register = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [CustomAgreement, setCustomAgreement] = useState(false);
  const [agreementType, setAgreementType] = useState(''); 
  // useEffect(() => {
    // getWechatAgreement(1).then(res => {
    //   setCustomAgreement(res.data)
    // })
  // }, )
  const [showModal, setShowModal] = useState(false);

  const handleAgree = () => {
    console.log('用户已同意协议');
    // 可以在这里执行用户同意后的操作，如设置本地存储标记
    localStorage.setItem('agreementAccepted', 'true');
  }

 
 

  // 验证确认密码
  const validateConfirmPassword = (_: any, value: any) => {
    if (!value) {
      return Promise.reject('请确认密码');
    }

    if (value !== form.getFieldValue('password')) {
      return Promise.reject('两次输入的密码不一致');
    }

    return Promise.resolve();
  };

  const validateEmail  = (_: any, value: any) => {
    if (!value) {
      return Promise.resolve();
    }

    if (value) {
      const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if (!re.test(value)) {
        return Promise.reject('请输入有效的邮箱地址');
      } else {
        return Promise.resolve();
      }
      
    }

    return Promise.resolve();
  };


  const onFinish = (values: any) => {
    console.log(888, values)
    if (!values.agreement) {
      Toast('请阅读勾选协议！');
      return;
    }
    setLoading(true);
    console.log(form);
    const data = { ...values };
    data.openId = localStorage.getItem('userOpenId');
    register(data)
      .then((res: any) => {
        if (res && res.code === 200) {
          Toast.success('注册成功！');
          history.push('/login');
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleLogin = () => {
    Toast('跳转到登录页面');
    // 实际应用中这里会使用路由跳转
  };

  const openModal = (type: string) => {
   
    setAgreementType(type);
    setShowModal(true)
  }

  return (
    <div className="register-container">
      <Helmet>
        <title>注册</title>
      </Helmet>
      <div className="register-form">
        <Form
          form={form}
          onFinish={onFinish}
          initialValues={{
            nickName: '',
            idNumber: '',
            password: '',
            confirmPassword: '',
            email: ''
          }}
        >
          <Form.Item
            name="nickName"
            label="用户名"
            rules={[
              { required: true, message: '请输入用户名' },
              { max: 20, message: '用户名不能超过20个字符' },
            ]}
          >
            <Field placeholder="请输入" clearable />
          </Form.Item>

          <Form.Item
            name="phonenumber"
            label="手机号"
            rules={[{ required: true, message: '请输入手机号' }, { pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: '请输入正确的手机号码'},]}
          >
            <Field placeholder="请输入" clearable />
          </Form.Item>

          <Form.Item
            name="idNumber"
            label="身份证号"
            rules={[{ validator: validateIdCard }]}
          >
            <Field placeholder="请输入" clearable />
          </Form.Item>

          <Form.Item
            name="password"
            label="密码"
            rules={[{ validator: validatePassword }]}
          >
            <Field
              type={showPassword ? 'text' : 'password'}
              placeholder="请输入"
              rightIcon={showPassword ? <EyeO /> : <ClosedEye />}
              onClickRightIcon={() => setShowPassword(!showPassword)}
            />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label="确认密码"
            rules={[{ validator: validateConfirmPassword }]}
          >
            <Field
              type={showConfirmPassword ? 'text' : 'password'}
              placeholder="请再次输入"
              rightIcon={showPassword ? <EyeO /> : <ClosedEye />}
              onClickRightIcon={() =>
                setShowConfirmPassword(!showConfirmPassword)
              }
            />
          </Form.Item>

          
          <Form.Item
            name="email"
            label="邮箱"
            rules={[{ validator: validateEmail }]}
          >
             <Field placeholder="请输入" clearable />
          </Form.Item>

          <Form.Item name="userType" label="业主类型">
              <Radio.Group>
                <Space>
                  <Radio name="业主">业主</Radio>
                  <Radio name="其他">其他</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>

          <div className="submit-btn">
            <Form.Item name="agreement" valuePropName="checked">
              <Checkbox shape="square" labelDisabled>
              <span className="agreement-text" >
                我已阅读并同意 <a href="#" onClick={() => openModal('user')}>《用户协议》</a> 和{' '}
                <a href="#" onClick={() => openModal('privacy')}>《隐私政策》</a>
              </span>
              </Checkbox>
             
            </Form.Item>

          

            <Button
              round
              block
              type="primary"
              nativeType="submit"
              loading={loading}
              loadingText="注册中..."
            >
              立即注册
            </Button>
          </div>
        </Form>

        <Divider>
          已有账户？
          <a href="" onClick={handleLogin}>
            前往登录
          </a>
        </Divider>
      </div>

      <AgreementModal 
        visible={showModal}
        onClose={() => setShowModal(false)}
        onAgree={handleAgree}
        type={agreementType}
        agreementContent={CustomAgreement} // 可选，不传则使用默认内容
      />
    </div>
  );
};

export default Register;
